import React from "react";
// import Xcountries from "./Components/XCountries";
// import XStopWatch from "./Components/XStopWatch";
// import XDisplayName from "./Components/XDisplayName";
// import XCounter from "./Components/XCounter";
// import XCalculator from "./Components/XCalculator";
// import XCountrySearch from "./Components/XCountrySearch";
// import XClassComp from "./Components/XClassComp";
// import XPagination from "./Components/XPagination";
// import XLogin from "./Components/XLogin";
// import XState from "./Components/XState";
import XWeatherApp from "./Components/XWeatherApp";

const App = () => {
  return (
    <>
      {/* <Xcountries/> */}
      {/* <XStopWatch/> */}
      {/* <XDisplayName/> */}
      {/* <XCounter/> */}
      {/* <XCalculator/> */}
      {/* <XCountrySearch/> */}
      {/* <XClassComp/> */}
      {/* <XPagination/> */}
      {/* <XLogin/> */}
      {/* <XState/> */}
      <XWeatherApp/>
    </>
  );
}

export default App;